import * as actionTypes from './actionTypes';

import { getNoArgDispatcherFunc, createActionObject } from '../../helpers/common';

export const toggleMainSideBar = getNoArgDispatcherFunc(actionTypes.TOGGLE_SIDE_BAR)

export const toggleLogOutDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_LOG_OUT_DIALOG)

export const setSelectedPath = path => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SELECTED_PATH,
    { path }
  )
)